import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { LoginUser } from '../models/users/signupUser';


@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {
  public user = new LoginUser();
  @Output() onLogin: EventEmitter<LoginUser> = new EventEmitter();
  @Output() forgot: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  onSubmit() {
    this.onLogin.emit(this.user);
  }

  forgotPassword() {
    this.forgot.emit();
  }

}
